import pathfinder from '@fiverr-private/pathfinder';
import { getContext } from '@fiverr-private/fiverr_context';
import { BUSINESS_TRIGGER_CTA, buildRedirectQueryParameters } from '@fiverr-private/business_success_sign_modal';
import { services } from '@fiverr-private/identification_core';

export interface SignUpProps {
    isSocialFlow: boolean;
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    username: string;
    inBeetlesMigrateSignupWebRollout: boolean;
    inBeetlesMigrateSocialSignUpRollout: boolean;
}

export const createUser = async ({
    isSocialFlow,
    email,
    username,
    password,
    firstName,
    lastName,
    inBeetlesMigrateSignupWebRollout = false,
    inBeetlesMigrateSocialSignUpRollout = false,
}: SignUpProps) => {
    if (isSocialFlow) {
        return services.createSocialUser({
            email,
            username,
            funnel: 'business',
            inBeetlesMigrateSocialSignUpRollout,
        });
    }

    return services.signUp({
        email,
        password,
        username,
        firstName,
        lastName,
        funnel: 'business',
        inBeetlesMigrateSignupWebRollout,
    });
};

export const buildRedirectUrl = ({ redirectUrl = '', source, type = BUSINESS_TRIGGER_CTA.DEFAULT }) => {
    // From landing page. Pathfinder for build URL and keep query param
    if (redirectUrl && (redirectUrl === '/' || redirectUrl.startsWith('/business'))) {
        const url = pathfinder('business_homepage', undefined, { query: { source } });
        return buildRedirectQueryParameters({ redirectUrl: url, source, type });
    }

    const { pathname, search } = new URL(getContext().url);
    const url = redirectUrl
        ? new URL(redirectUrl, window.location.origin)
        : new URL(pathname + search, window.location.origin);

    const shouldRedirectToFullCatalog = source === 'seamless_reg_listing';
    if (shouldRedirectToFullCatalog) {
        url.searchParams.set('expert_listings', 'false');
    }

    return buildRedirectQueryParameters({ redirectUrl: url.toString(), source, type });
};
